import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ChatAIPopUpModal } from '@components/modal-chat-ai/modal-chat-ai.component';

@Injectable({
    providedIn: 'root'
})
export class ChatService {

    private modalChat: HTMLIonModalElement;

    constructor(private modalController: ModalController) { }

    async openChatPopup() {
        this.modalChat = await this.modalController.create({
            component: ChatAIPopUpModal,
            cssClass: 'chat-ai-modal',
            backdropDismiss: false,
            showBackdrop: false
        });

        return await this.modalChat.present();
    }

    async closeChatAIPopup() {
        this.modalChat.dismiss();
    }
}
